<template>
	<div class="header">
		<div class="container header-container">
			<router-link to="/home" class="logoHref">
				<img src="../../assets/img/index/logo.png" alt="" />
			</router-link>
			<Nav></Nav>
			<div class="user_operation">
        <!-- <a class="user_btn" href="http://120.224.135.45:8580/shipper/user/login" target="_blank">登录</a>
        <b>|</b>
        <a class="user_btn" href="http://120.224.135.45:8580/shipper/user/reg" target="_blank">注册</a>
        <b>|</b>
        <a class="user_btn" href="http://120.224.135.45:8580/shipper/consignor/log" target="_blank">TMS发货</a>
        <b>|</b>
        <a class="user_btn" href="http://120.224.135.45:8580/shipper/orders/queryOrder" target="_blank">TMS查询</a> -->
				<a class="user_btn" href="https://www.so56.net/shipper/user/login" target="_blank">登录</a>
				<b>|</b>
				<a class="user_btn" href="https://www.so56.net/shipper/user/reg" target="_blank">注册</a>
				<b>|</b>
				<a class="user_btn" href="https://www.so56.net/shipper/consignor/log" target="_blank">TMS发货</a>
				<b>|</b>
				<a class="user_btn" href="https://www.so56.net/shipper/orders/queryOrder" target="_blank">TMS查询</a>
			</div>
		</div>
	</div>

</template>

<script>
	import Nav from "./nav.vue"
	import axios from 'axios'
	export default{
		components: {
			Nav
		},
		created: function(){

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import '../../assets/stylus/base.styl';
	.header
		border-bottom: 1px solid #d7d7d7
		.header-container
			height: 60px
			position: relative
			.logoHref
				position: absolute
				left: 0
				top: 10px
				display: inline-block
			.user_operation
				position: absolute
				width: 260px
				right: 0
				top: 0
				height: 60px
				line-height: 60px
				color: #979ea7
				.user_btn
					color: #979ea7
					display: inline-block
					padding: 0 5px
			.nav-box
				padding: 0 110px
				padding-right: 300px
				@media screen and (max-width: 1400px)
					padding: 0 100px
					padding-right: 260px
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue